var ref = {};

ref.getCachedForKeyWithMaxAge = function(key, maxAge) {
  try {
    var data = window.localStorage[key];
    if (data) {
      var entry = JSON.parse(data);
      var now = new Date().getTime();
      if (maxAge === 0 || (maxAge && entry.ts < now - maxAge)) {
        console.warn("Cached data expired or maxAge ===0, key = " + key);
        return null;
      } else {
        console.log("CACHED Hit !!");
        return entry.value;
      }
    }
  } catch (e) {
    // console.warn(':: cached error', e)
  }
  return null;
};

ref.saveCacheForKeyAndValue = function(key, value) {
  try {
    if (value) {
      window.localStorage[key] = JSON.stringify({
        value: value,
        ts: new Date().getTime()
      });
    }
  } catch (e) {
    console.warn(":: cache error", e);
    // when failed to save cache, try to automatic clear old backup
    // this could happen automatic
    ref.clearOldCache();
    return false;
  }
  return true;
};

// always return cached value if available

ref.getCachedForKey = function(key) {
  try {
    // pull with non checking the timestamp
    var data = window.localStorage[key];
    if (data) {
      console.log("getCachedForKey !!!! CACHED Hit !!");
      var entry = JSON.parse(data);
      return entry.value;
    }
  } catch (e) {
    console.warn("::getCachedForKey error", e);
  }
  return null;
};

ref.clearOldCache = function() {
  console.log("size BEFORE clear old cache --> ");
  ref.checkLocalStorageSize();
  // clear cache that older than 3 days
  var maxAge = 3 * 24 * 60 * 60 * 1000; // 3 days
  var now = new Date().getTime();

  for (var i = 0; i < window.localStorage.length; i++) {
    var key = window.localStorage.key(i);
    var data = window.localStorage[key];
    if (data) {
      var entry = JSON.parse(data);
      // delete data that older than maxAge (3 days)
      if (maxAge && entry.ts < now - maxAge) {
        delete window.localStorage[key];
        console.log("clear: " + key);
      }
    }
  }
  console.log("size AFTER clearOldCache --> ");
  ref.checkLocalStorageSize();
};

ref.checkLocalStorageSize = function() {
  var _lsTotal = 0;
  var _xLen;
  var _x;
  for (_x in window.localStorage) {
    _xLen = (window.localStorage[_x].length + _x.length) * 2;
    _lsTotal += _xLen;
    console.log(_x.substr(0, 50) + " = " + (_xLen / 1024).toFixed(2) + " KB");
  }
  console.log("Total = " + (_lsTotal / 1024).toFixed(2) + " KB");
};

export default ref;
